import React from 'react';
import { Channel } from '../../../../shared/types';
import { useQuery } from '@apollo/react-hooks';
import { GET_FREE_CHANNELS } from '../../../../gql/channels';
import { ChannelsSection } from './ChannelsSection';
import { ChannelsGridProps, prepareChannelsToShow } from './ChannelsGridUtils';

export const FreeChannels = (props: ChannelsGridProps) => {
	const { randomize = false, quantityToDisplay } = props;
	const { loading, data } = useQuery(GET_FREE_CHANNELS, { fetchPolicy: 'network-only' });
	const freeChannels = prepareChannelsToShow(data?.freeChannels, randomize, quantityToDisplay) as Channel[];

	return (
		<ChannelsSection
			title="Free to subscribe"
			channels={freeChannels}
			loading={loading}
			type="free"
		/>
	);
}
